import { AppState as State } from '@ducks/index';

export const getRefreshId = (state: State) => state.notification.refresh;
export const checkIsLoading = (state: State) => state.notification.isLoading;
export const checkIsSubmitting = (state: State) => state.notification.isSubmitting;
export const getNotifications = (state: State) => state.notification.notifications;
